// Copyright (c) 2025-2026 NacenCheck — TracePro Compliance-Grade Trace OS.
// Licensed under the MIT License — see LICENSE file in the repo root.
// SPDX-License-Identifier: MIT

import { createApiClient, busDefaultHandlers } from "@tracepro/api-client";
import { offlineReadCache } from "@tracepro/mobile-screens/lib/offline-read-cache";

// R9 (2026-05-20): web-app chuyển same-origin như gov-portal / admin-portal.
// nginx uat.nacencheck.com proxy /api/ + /auth/ sang api-gateway. baseUrl rỗng
// = fetch tương đối /api/v1/... → hết CORS preflight + hết cross-origin cookie
// + Service Worker PWA xử lý same-origin tin cậy (không trả nhầm offline.html).
// Khi NEXT_PUBLIC_API_URL được set (build cũ / dev) thì vẫn dùng giá trị đó.
function resolveApiBaseUrl(): string {
  const url = process.env.NEXT_PUBLIC_API_URL;
  if (url && url.trim() !== "") {
    return url;
  }
  return ""; // same-origin
}

export function getApiClient(getToken: () => Promise<string | null>) {
  return createApiClient({
    baseUrl: resolveApiBaseUrl(),
    getToken,
    // /m/ ghi nhật ký offline: biểu mẫu/danh mục/thửa đọc lúc có mạng được giữ lại.
    readCache: offlineReadCache,
    // Phase 54 W4.5 — publish 401/403/429/5xx events to the bus so the React
    // tree's `useApiErrorHandler()` (in root layout) can route + toast.
    ...busDefaultHandlers(),
  });
}

/**
 * @deprecated Use getApiClient() — direct API_URL access bypasses lazy env resolution
 * and breaks prerender of static error pages. Resolved on demand at call time.
 */
export function getApiUrl(): string {
  return resolveApiBaseUrl();
}
